<template>

  <figure class="mb-0" v-if="!splideMounted && item.notHiddenImages[0]">
    <picture>
      <img :src="item.notHiddenImages[0].getTyrionSrc('thumbw', $showWebp ? 'webp' : null)"
           :alt="`${item.notHiddenImages[0].alt ? item.notHiddenImages[0].alt : item.notHiddenImages[0].title}, ${item.notHiddenImages[0].title}`"
           :width="item.notHiddenImages[0].seoWidth('thumb')"
           :height="item.notHiddenImages[0].seoHeight('thumb')"
           class="img-cover img-border">
    </picture>
  </figure>
  <div class="splide" v-if="item.hasImage(false)" ref="splideContainer">

    <div class="splide__track">
      <div class="splide__list">
        <div class="splide__slide" v-for="(image, index) in item.notHiddenImages.slice(0,5)"
             :key="image.id + '_' + index + '_' + item.id">
          <NuxtLink :to="hrefLink ? hrefLink : item.getLinkWithSlash()" :target="hrefTarget()"
                    :title="`${$t('offer-detail')} - ${item.title}`"
                    @click.native="hrefAction">
            <figure class="mb-0">
              <picture>
                <img :src="image.getTyrionSrc('thumbw', $showWebp ? 'webp' : null)"
                     :alt="`${image.alt ? image.alt : item.title}, ${image.title}`"
                     :loading="index === 0 ? 'eager' : 'lazy'"
                     :width="image.seoWidth('thumb')"
                     :height="image.seoHeight('thumb')"
                     class="img-cover img-border">
              </picture>
            </figure>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>


  <NuxtLink v-else :to="hrefLink ? hrefLink : item.getLinkWithSlash()" :target="hrefTarget()"
            :title="`Detail ponuky - ${item.title}`" class="no-image">
    <img src="~/assets/img/blank.jpg" :alt="item.title" class="img-cover img-border no-product-image" loading="lazy"
         width="600" height="337">
  </NuxtLink>

</template>


<script setup lang="ts">
import {onMounted, PropType, ref} from "vue";
import Accommodation from "../../../../../lib/models/Accommodation";
import {useNuxtApp} from "#app";

const {$isDesktop, $showWebp, $splide} = useNuxtApp();
const props = defineProps({
  item: Object as PropType<Accommodation>,
  hrefLink: String,
})

const emit = defineEmits(['hrefAction']);
const splideMounted = ref(false);
const splideContainer = ref(null);

const hrefTarget = () => {
  return $isDesktop() ? "_blank" : "_self"
}

const hrefAction = () => {
  emit('hrefAction');
}

onMounted(async () => {
  const Splide = await $splide();
  if (props.item.hasImage(false)) {
    setTimeout(() => {
      new Splide(splideContainer.value, {
        type: 'fade',
        perPage: 1,
        speed: 500,
        rewind: true,
        arrows: props.item.images.length > 1,
        pagination: props.item.images.length > 1,
        autoplay: false
      }).mount();
      setTimeout(() => {
        splideMounted.value = true;
      }, 300);
    }, Math.floor(Math.random() * (150 - 80 + 1)) + 80);


  }
});

</script>
